import { render, staticRenderFns } from "./TranslateDropdown.vue?vue&type=template&id=8e9d58a0&scoped=true&"
import script from "./TranslateDropdown.vue?vue&type=script&lang=js&"
export * from "./TranslateDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TranslateDropdown.vue?vue&type=style&index=0&id=8e9d58a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9d58a0",
  null
  
)

export default component.exports